var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "factor-base-reveal-network" },
    [
      _vm.legendItems.length || _vm.showMetricLegends
        ? _c("div", { staticClass: "network-legend mb-2" }, [
            _vm.legendItems.length
              ? _c(
                  "div",
                  { staticClass: "network-legend-row" },
                  _vm._l(_vm.legendItems, function (item, i) {
                    return _c(
                      "span",
                      { key: "c-" + i, staticClass: "legend-item" },
                      [
                        _c("span", {
                          staticClass: "legend-swatch",
                          style: { backgroundColor: item.color },
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" " + _vm._s(item.label) + " "),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.showMetricLegends
              ? _c(
                  "div",
                  { staticClass: "network-legend-row network-legend-metrics" },
                  [
                    _vm.showNodeSizeLegend
                      ? _c("span", { staticClass: "legend-metric-item" }, [
                          _vm._m(0),
                          _c("span", [_vm._v(_vm._s(_vm.nodeSizeLegendText))]),
                        ])
                      : _vm._e(),
                    _vm.showEdgeLengthLegend
                      ? _c("span", { staticClass: "legend-metric-item" }, [
                          _vm._m(1),
                          _c("span", [
                            _vm._v(_vm._s(_vm.edgeLengthLegendText)),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "network-wrapper" }, [
        _c("div", {
          ref: "container",
          staticClass: "network-container",
          style: { height: _vm.height + "px" },
        }),
        _vm.hoverTooltip.visible
          ? _c("div", {
              staticClass: "network-hover-tooltip",
              style: {
                left: _vm.hoverTooltip.x + "px",
                top: _vm.hoverTooltip.y + "px",
              },
              domProps: { innerHTML: _vm._s(_vm.hoverTooltip.content) },
            })
          : _vm._e(),
        _vm.diseaseNodeMenu.visible
          ? _c(
              "div",
              {
                staticClass: "network-disease-action-menu",
                style: {
                  left: _vm.diseaseNodeMenu.x + "px",
                  top: _vm.diseaseNodeMenu.y + "px",
                },
                attrs: { role: "menu", "aria-label": _vm.diseaseNodeMenuLabel },
                on: {
                  mouseenter: _vm.cancelDiseaseMenuHide,
                  mouseleave: _vm.scheduleDiseaseMenuHide,
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "network-disease-action-btn",
                    attrs: { type: "button", role: "menuitem" },
                    on: { click: _vm.onDiseaseMenuViewSharedGenes },
                  },
                  [_vm._v(" View shared genes ")]
                ),
              ]
            )
          : _vm._e(),
        _vm.visNetwork
          ? _c(
              "div",
              { staticClass: "zoom-slider-outer" },
              [
                _c("div", { staticClass: "zoom-slider-block" }, [
                  _c("label", { staticClass: "zoom-slider-label" }, [
                    _vm._v("Zoom"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.zoomLevel,
                        expression: "zoomLevel",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "zoom-slider",
                    attrs: {
                      type: "range",
                      min: _vm.zoomMin,
                      max: _vm.zoomMax,
                      step: _vm.zoomStep,
                    },
                    domProps: { value: _vm.zoomLevel },
                    on: {
                      input: _vm.applyZoom,
                      __r: function ($event) {
                        _vm.zoomLevel = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
                _vm.showHypothesisMapViewToggle
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "zoom-slider-divider",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("|")]
                      ),
                      _c(
                        "label",
                        { staticClass: "hypothesis-map-original-label" },
                        [
                          _c("input", {
                            staticClass: "hypothesis-map-original-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.showOriginalHypothesisMap,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit(
                                  "hypothesis-original-map",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _vm._v(" Original map "),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm.showPopupButton
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "zoom-slider-divider",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("|")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm btn-outline-secondary network-popup-btn",
                          attrs: {
                            type: "button",
                            "aria-label": "Open in larger view",
                            title: "Open in larger view",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("open-popup")
                            },
                          },
                        },
                        [_c("b-icon", { attrs: { icon: "fullscreen" } })],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm.nodeSelectionEnabled
        ? _c("workflow-heatmap-node-action-menu", {
            attrs: {
              open: _vm.networkNodeMenuOpen,
              target: _vm.networkNodeMenuTarget,
              "is-selected": _vm.networkNodeMenuIsSelected,
              left: _vm.networkNodeMenuLeft,
              top: _vm.networkNodeMenuTop,
            },
            on: {
              close: _vm.closeNetworkNodeMenu,
              "toggle-select": _vm.onNetworkNodeMenuToggle,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "legend-size-demo", attrs: { "aria-hidden": "true" } },
      [
        _c("span", {
          staticClass: "legend-size-circle legend-size-circle--sm",
        }),
        _c("span", {
          staticClass: "legend-size-circle legend-size-circle--lg",
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "legend-edge-demo", attrs: { "aria-hidden": "true" } },
      [
        _c("span", { staticClass: "legend-edge-line legend-edge-line--short" }),
        _c("span", { staticClass: "legend-edge-line legend-edge-line--long" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }